module.exports = __webpack_public_path__ + "static/media/VittorioGragnaniello.c5cec745.jpg";